// This is a higher order component to use with goodies that are positioned relative to the animal.
// ie. _Glasses.js

import React from 'react';
import _ from 'lodash';

// --- 1. Import your goodies.

// import Raybans from './Raybans.js';
// ...


// --- 2. Add them to your options object.

// let glassesOptions = {
// 	Raybans,
// 	...
// };

class PositionedGoodyParentHOC extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			goodyMarkerCoords: {},
		};

		this.getMarkerCoords = this.getMarkerCoords.bind(this);
	}

	getMarkerCoords(markerElement) {
		if (!markerElement) {
			return;
		}

		this.setState({ goodyMarkerCoords: {
			y: markerElement.cy.baseVal.value,
			x: markerElement.cx.baseVal.value,
		} });
	}

	getPosition() {
		if (_.isEmpty(this.props.targetCoords) || _.isEmpty(this.state.goodyMarkerCoords)) {
			return {
				x: 0,
				y: 0
			};
		}

		return {
			x: this.props.targetCoords.x - this.state.goodyMarkerCoords.x,
			y: this.props.targetCoords.y - this.state.goodyMarkerCoords.y,
		};
	}

	// --- 3. Add this to your goody and replace glasses with your type...

	// render() {
	// 	let Goody = glassesOptions[this.props.glasses];
	//
	// 	return (
	// 		<svg ref={POSITIONED_GOODY_REFS.GOODY_CONTAINER} {...this.getPosition()}>
	// 			<Glasses getMarkerCoords={this.getMarkerCoords} />
	// 		</svg>
	// 	);
	// }
}

export default PositionedGoodyParentHOC;



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/PositionedGoodyParentHOC.js